import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import SecureBaseStore from "./SecureBaseStore";
import LoadingStates from "../constants/states/LoadingStates";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";


class AdvertisementReservationState {
    constructor(
        loadingState,
        reservationRequests,
        activeReservations,
        history
    ) {
        this.loadingState = loadingState;
        this.reservationRequests = reservationRequests;
        this.activeReservations = activeReservations;
        this.history = history;
    }

    equals(other) {
        return this.loadingState ===other.loadingState &&
            this.arraysEqual(this.reservationRequests, other.reservationRequests) &&
            this.arraysEqual(this.activeReservations, other.activeReservations) &&
            this.arraysEqual(this.history, other.history);
    }

    arraysEqual = (a1, a2) =>
        a1.length === a2.length && a1.every((o, idx) => o.equals(a2[idx]));
}

class ImmutableAdvertisementReservationStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.reservationRequests = [];
        this.activeReservations = [];
        this.history = [];
    }

    static fromState(state) {
        return new ImmutableAdvertisementReservationStateBuilder()
            .setLoadingState(state.loadingState)
            .setReservationRequests(state.reservationRequests)
            .setActiveReservations(state.activeReservations)
            .setHistory(state.history)
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    setReservationRequests(reservationRequests) {
        this.reservationRequests = reservationRequests;
        return this;
    }

    setActiveReservations(activeReservations) {
        this.activeReservations = activeReservations;
        return this;
    }

    setHistory(history) {
        this.history = history;
        return this;
    }

    build() {
        return Object.freeze(
            new AdvertisementReservationState(
                this.loadingState,
                this.reservationRequests,
                this.activeReservations,
                this.history
            ));
    }
}


class AdvertisementReservationStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.ADVERTISEMENT_RESERVATIONS_STORE_UPDATED, ImmutableAdvertisementReservationStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_RESERVATIONS_UNMOUNTED, this.resetStore);
        this.subscribeToEvent(ActionResultEvents.MEMBER_ADVERTISEMENT_RESERVATIONS_LOADED, this.handleMemberAdvertisementReservationsLoaded);
        this.subscribeToEvent(UIInteractionEvents.GET_MEMBER_ADVERTISEMENTS_RESERVATIONS, this.handleLoading);
    }

    handleLoading = (topic, data) => {
        return new ImmutableAdvertisementReservationStateBuilder()
            .setLoadingState(LoadingStates.LOADING)
            .build();
    }

    handleMemberAdvertisementReservationsLoaded = (topic, data) => {
        return new ImmutableAdvertisementReservationStateBuilder()
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .setReservationRequests(data.reservationRequests)
            .setActiveReservations(data.activeReservations)
            .setHistory(data.history)
            .build();
    }
}

export default new AdvertisementReservationStore();